<section>
  <h1 class="evn-text-subhead-2 cg-margin-bottom-sm">
    {{ 'login.form.header' | translate }}
  </h1>

  <form
    action="/pkmslogin.form"
    id="login-form"
    method="POST"
    ngNoForm
    (submit)="submit()"
  >
    <input type="hidden" name="login-form-type" value="pwd" />
    <div class="cg-margin-top-md">
      <div>
        <label for="username">{{ 'login.form.username' | translate }}</label>
        <div class="cg-margin-top-xs">
          <input
            cignaInput
            type="text"
            name="username"
            id="username"
            cignaTrimInputWhitespace
            [formControl]="username"
            data-test="username"
            autocomplete="username"
          />
        </div>
        <div
          *ngIf="
            (status !== 'wamerror' &&
              status !== 'nowam' &&
              status !== 'deny' &&
              username.invalid &&
              username.touched) ||
            (username.invalid && username.dirty)
          "
          class="cg-error-msg"
          data-test="username-error"
        >
          <cigna-icon type="exclamation-circle"></cigna-icon>
          <span>{{ 'login.form.validationUsername' | translate }}</span>
        </div>
      </div>
      <div class="cg-margin-top-md">
        <label for="password">{{ 'login.form.password' | translate }}</label>
        <div class="cg-margin-top-xs">
          <input
            cignaInput
            type="password"
            name="password"
            id="password"
            cignaTrimInputWhitespace
            [formControl]="password"
            data-test="password"
            autocomplete="current-password"
          />
        </div>
        <div
          *ngIf="
            (status !== 'wamerror' &&
              status !== 'nowam' &&
              status !== 'deny' &&
              password.invalid &&
              password.touched) ||
            (password.invalid && password.dirty)
          "
          class="cg-error-msg"
          data-test="password-error"
        >
          <cigna-icon type="exclamation-circle"></cigna-icon>
          <span>{{ 'login.form.validationPassword' | translate }}</span>
        </div>
        <div
          *ngIf="
            status === 'wamerror' || status === 'nowam' || status === 'deny'
          "
          class="cg-error-msg"
          data-test="wam-message"
          style="display: block"
        >
          <!-- Has WAM messaging -->
          <ng-container *ngIf="status === 'wamerror'">
            Account not activated. Contact your
            <button cignaButton="link" (click)="openWamFaqModal(true)">
              website access manager.
            </button>
          </ng-container>
          <!-- No WAM messaging -->
          <ng-container *ngIf="status === 'nowam'">
            TIN's access has not been activated.
            <button cignaButton="link" (click)="openWamFaqModal(false)">
              Learn more.
            </button>
          </ng-container>

          <ng-container *ngIf="status === 'deny'">
            Account inactive.
          </ng-container>
        </div>
        <div
          class="evn-text-paragraph-body-small cg-margin-top-md cg-margin-bottom-lg"
        >
          {{ 'login.form.existingCreds' | translate }}
        </div>
        <div class="cg-text-center">
          <a
            data-test="forgot-username-link"
            routerLink="/identity/forgot/userid"
            [cignaTrackClicks]="[
              'trackEventOther',
              'Forgot username',
              'ac22391',
              {
                eVar120: 'forgot-username',
                eVar119: 'US1880991'
              }
            ]"
            >{{ 'login.form.forgotUsername' | translate }}</a
          >

          |
          <a
            data-test="forgot-password-link"
            routerLink="/identity/forgot/password"
            [cignaTrackClicks]="[
              'trackEventOther',
              'Forgot password',
              'ac22392',
              {
                eVar120: 'forgot-password',
                eVar119: 'US1880992'
              }
            ]"
            >{{ 'login.form.forgotPassword' | translate }}</a
          >
        </div>
      </div>

      <div class="cg-margin-top-md">
        <button
          cignaButton="primary"
          type="submit"
          [disabled]="isSubmitted"
          data-test="login-submit-button"
        >
          {{ 'login.form.login' | translate }}
        </button>
      </div>
      <hr />
    </div>
    <div class="cg-margin-top-md">
      <div class="evn-text-subhead-3">
        {{ 'login.form.createdAccount' | translate }}
      </div>
      <div class="cg-margin-top-md">
        <a
          routerLink="/registration"
          cignaButton="secondary"
          data-test="register-button"
          [cignaTrackClicks]="[
            'trackEventOther',
            'Register',
            'ac22394',
            {
              eVar120: 'register-button',
              eVar119: 'US1880997'
            }
          ]"
        >
          {{ 'login.form.register' | translate }}
        </a>
      </div>
      <div class="cg-text-center cg-margin-top-md">
        <a
          data-test="how-to-register-link"
          target="resourcesWindow"
          [href]="
            '/resourceLibrary/howToRegister'
              | resourceLink : { secure: false, targetApp: 'evernorth' }
              | async
          "
          [cignaTrackClicks]="[
            'trackEventOther',
            'How to register',
            'ac22395',
            {
              eVar120: 'how-to-register-link',
              eVar119: 'US1880999'
            }
          ]"
          >{{ 'login.form.howTo' | translate }}</a
        >
        |
        <a
          routerLink="/registration/tempid"
          data-test="temp-id-link"
          [cignaTrackClicks]="[
            'trackEventOther',
            'Temporary ID',
            'ac22396',
            {
              eVar120: 'temporary-id-link',
              eVar119: 'US1881001'
            }
          ]"
          >{{ 'login.form.tempId' | translate }}</a
        >

        <button
          class="cg-margin-left-sm"
          cignaButton="link inline no-underline"
          type="button"
          (click)="openWhatIsTemporaryIdModal()"
          data-test="login-tempid-help-link"
          aria-label="What is a temporary ID"
        >
          <cigna-icon type="question-mark-circle"></cigna-icon>
        </button>
      </div>
    </div>
  </form>
</section>
